<template>
  <div>
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ scoreConditionName }}
      </h1>
      <div class="d-flex justify-content-end align-items-center">
        <p class="mr-2">Score :</p>
        <InputNumber
          textFloat=""
          placeholder="Score"
          class="w-30"
          v-model="form.score"
          disabled
        />
        <p class="ml-2">{{ $t("point") }}</p>
        <button
          v-if="scoreConditionName !== 'End the conversation'"
          type="button"
          @click="handleClickOpenModal()"
          :disabled="isBusy"
          class="btn btn-main ml-md-2 mb-2"
        >
          Create
        </button>
      </div>
    </div>
    <div class="bg-white-border p-3 text-black main-theme">
      <SettingWordListTable
        :isBusy="isBusy"
        :items="conditionData"
        :fields="fields"
        :v="$v"
        @onDelete="handleClickDeleteItem"
        @onEdit="handleClickEditItem"
      />
      <div v-if="scoreConditionName === 'End the conversation'">
        <hr />
        <button
          type="button"
          @click="handleAddItem()"
          :disabled="isBusy"
          class="btn btn-main btn-details-set text-uppercase"
        >
          <font-awesome-icon icon="plus-square" />
          Add
        </button>
      </div>
      <b-row>
        <b-col cols="12" class="text-sm-right">
          <button
            type="button"
            @click="handleSubmit()"
            :disabled="isBusy"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
    <SettingWordModal
      ref="settingWordModal"
      :title="scoreConditionName"
      :selectedItem="selectedItem"
      @onCloseModal="onCloseModal"
      @onSaveModal="handleClickSubmitModal"
    />
  </div>
</template>

<script>
import InputNumber from "@/components/inputs/InputNumber";
import SettingWordListTable from "./components/SettingWordListTable.vue";
import SettingWordModal from "./components/SettingWordModal.vue";
import { required, integer, requiredIf } from "vuelidate/lib/validators";
export default {
  name: "SettingWordIndex",
  components: {
    InputNumber,
    SettingWordListTable,
    SettingWordModal,
  },
  data() {
    return {
      pathName: window.location.pathname,
      form: {
        score: 0,
      },
      fields: [
        {
          key: "name",
          label: "Condition",
        },
        {
          key: "score",
          label: "Score",
        },
        {
          key: "isActive",
          label: "Status",
        },
      ],
      items: [],
      isBusy: false,
      selectedItem: {},
    };
  },
  validations: {
    form: {
      conditions: {
        $each: {
          name: {
            required,
          },
          score: {
            required,
            integer,
          },
        },
      },
    },
  },
  computed: {
    scoreConditionName() {
      var result = "";
      if (this.pathName) {
        const segments = this.pathName.split("/");
        const thirdPart = segments[2];
        if (thirdPart) {
          if (thirdPart == "accuracy") {
            result = "Word Accuracy";
          } else if (thirdPart == "negative") {
            result = "Negative Words";
          } else {
            const index = this.fields.findIndex((f) => f.key === "isActive");
            const alreadyExists = this.fields.some((f) => f.key === "status");
            if (index !== -1 && !alreadyExists) {
              this.fields[index].label = "";
              this.fields.splice(index, 0, {
                key: "isActiveMatchingPhrases",
                label: "statusActive",
              });
            }

            result = "End the conversation";
          }
        }
      }
      return result;
    },
    conditionData() {
      if (this.form.conditions && this.form.conditions.length > 0) {
        return this.form.conditions.filter((x) => !x.isDeleted);
      } else {
        return [];
      }
    },
  },
  async created() {
    await this.getConditionByName();
  },
  methods: {
    async getConditionByName() {
      this.isBusy = true;
      const response = await this.axios.get(
        `${this.$baseUrl}/ScoreSetting/${this.scoreConditionName}`
      );
      if (response && response.result === 1 && response.detail) {
        this.form = response.detail;
      }
      this.isBusy = false;
    },
    async handleSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.isBusy = true;

      const { id, conditions } = this.form;

      const response = await this.axios.put(
        `${this.$baseUrl}/ScoreSetting/Conditions/${id}`,

        conditions
      );
      if (response && response.result === 1) {
        this.$store.commit("UPDATE_GLOBAL_ALERT", {
          isShow: true,
          msg: response.message,
        });
      } else {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: response.message || "Something went wrong",
        });
      }
      await this.getConditionByName();
      this.isBusy = false;
    },
    handleClickOpenModal() {
      this.$refs.settingWordModal.showModal = true;
    },
    onCloseModal() {
      this.selectedItem = {};
    },
    handleAddItem() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.form.conditions.push({
        score: 0,
        name: "",
        isMatchingPhrases: true,
        isDeleted: false,
      });
    },
    handleClickDeleteItem(item) {
      const index = this.form.conditions.findIndex((x) => x.id === item.id);
      if (index > -1) {
        this.form.conditions[index].isDeleted = true;
      }
    },
    handleClickEditItem(item) {
      this.selectedItem = { ...item };
      this.handleClickOpenModal();
    },
    handleValidate(item) {
      let result = {
        error: false,
        message: "",
      };

      const from = Number(item.from);
      const to = Number(item.to);
      const score = Number(item.score);

      if (score > 0) {
        return {
          error: true,
          message: "Score must be less than 0",
        };
      }

      if (to !== 0 && to < from) {
        return {
          error: true,
          message: "'To' must be greater than or equal to 'From'",
        };
      }

      const isNameDuplicate = this.form.conditions.some((x) => {
        return item.id
          ? x.name === item.name && x.id !== item.id
          : x.name === item.name;
      });

      if (isNameDuplicate) {
        return {
          error: true,
          message: "Name already exists",
        };
      }

      const isOverlap = this.form.conditions.some((x) => {
        if (item.id && x.id === item.id) return false;

        const xFrom = Number(x.from);
        const xTo = Number(x.to);
        const xRealTo = xTo === 0 ? Infinity : xTo;

        const itemFrom = from;
        const itemTo = to === 0 ? Infinity : to;

        return (
          (itemFrom >= xFrom && itemFrom <= xRealTo) ||
          (itemTo >= xFrom && itemTo <= xRealTo) ||
          (itemFrom <= xFrom && itemTo >= xRealTo)
        );
      });

      if (isOverlap) {
        return {
          error: true,
          message: "Range overlaps with existing condition",
        };
      }

      return result;
    },

    handleClickSubmitModal(item) {
      let index = -1;

      if (item.id) {
        index = this.form.conditions.findIndex((x) => x.id === item.id);
      } else {
        index = this.form.conditions.findIndex((x) => x.name === item.name);
      }
      const isError = this.handleValidate(item);

      if (isError.error) {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: isError.message,
        });
      } else {
        if (index > -1) {
          Object.assign(this.form.conditions[index], item);
        } else {
          this.form.conditions.push(item);
        }
        this.$refs.settingWordModal.onCloseModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
